var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_11490_7342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33329 0.666504H2.66663C1.56206 0.666504 0.666626 1.56193 0.666626 2.6665V5.33317C0.666626 6.43774 1.56206 7.33317 2.66663 7.33317H5.33329C6.43786 7.33317 7.33329 6.43774 7.33329 5.33317V2.6665C7.33329 1.56193 6.43786 0.666504 5.33329 0.666504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0.666504H10.6666C9.56206 0.666504 8.66663 1.56193 8.66663 2.6665V5.33317C8.66663 6.43774 9.56206 7.33317 10.6666 7.33317H13.3333C14.4379 7.33317 15.3333 6.43774 15.3333 5.33317V2.6665C15.3333 1.56193 14.4379 0.666504 13.3333 0.666504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33329 8.6665H2.66663C1.56206 8.6665 0.666626 9.56193 0.666626 10.6665V13.3332C0.666626 14.4377 1.56206 15.3332 2.66663 15.3332H5.33329C6.43786 15.3332 7.33329 14.4377 7.33329 13.3332V10.6665C7.33329 9.56193 6.43786 8.6665 5.33329 8.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.6665H10.6666C9.56206 8.6665 8.66663 9.56193 8.66663 10.6665V13.3332C8.66663 14.4377 9.56206 15.3332 10.6666 15.3332H13.3333C14.4379 15.3332 15.3333 14.4377 15.3333 13.3332V10.6665C15.3333 9.56193 14.4379 8.6665 13.3333 8.6665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11490_7342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.a1d52e552ee11c31796f69cf5e1c4c77.svg";
export { ForwardRef as ReactComponent };